import { render, staticRenderFns } from "./YoutubePlayer.vue?vue&type=template&id=2ac4e006&"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js&"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports